export const GEOMARKER_DEFAULT_GROUP = "misc";